import React from 'react'
import { TbWorldStar } from "react-icons/tb";

type CardLocationProps = {
  location: string;
}

/**
 * CardLocation - Displays a location with a globe icon
 * 
 * This component was moved from NewsCardLocation to be part of the DataCardTable
 * component series, as it's used in Campaign pages but not related to the News feature.
 */
export default function CardLocation({location}: CardLocationProps) {
  return (
    <div className="flex flex-row gap-2 items-center text-sm">
      <TbWorldStar />
      {location}
    </div>
  )
}